/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-02
 *
 **/

import {httpClient} from "./http-client";

/**
 * Consulta si un trámite ya se encuentra en el Carrito
 *
 * @param data, formulario con procedure_id, stage_id, field_id
 * @returns {Promise<AxiosResponse<any>>}
 */
const postIsProcedureInCart = (data) => httpClient.post('carrito/has_procedure', data)

/**
 * Agrega un trámite al carrito
 *
 * @param data, formulario datos del tramite
 * @returns {Promise<AxiosResponse<any>>}
 */
const addProcedureToCart = (data) => httpClient.post('carrito/agregar_a_carrito', data)

/**
 * Obtiene el numero de trámites en el carrito
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const getNumberOfItems = (data) => httpClient.post('carrito/numero_tramites', data)

/**
 * Obtiene todos lo informacion de tramites en portafolio, lista de espera y resumen de la transaccion
 * en el paso 1 del carrito
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const getCartStep1 = (data) => httpClient.post('carrito/paso_1', data)

/**
 * Obtiene todos los tramites contenidos en un grupo,
 * ya que inicialmente solo se muestran los primeros 5 elementos del grupo
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const getProcedureAllItems = (data) => httpClient.post('carrito/ver_todo_paso_1', data)

/**
 *Mueve un grupo de tramites en lista d espera a carrito
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const moveProcedureToCart = (data) => httpClient.post('carrito/mover_a_carrito', data)

/**
 * Mueve un grupo de tramites en carrito a lista de espera
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const moveProcedureToWishlist = (data) => httpClient.post('carrito/mover_a_espera', data)

/**
 * Obtiene todos elementos del checkout en el carrito 1 (inicialmente solo trae los primeros 5)
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const getCheckoutAllItems = (data) => httpClient.post('carrito/checkout_detalles', data)

/**
 *Remueve el grupo de tramites seleccionado
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const removeItem = (data) => httpClient.post('carrito/quitar_tramite', data)

/**
 * Envia los tramites seleccionados al paso 2 del carrito
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const getCartStep2 = (data) => httpClient.post('carrito/paso_2', data)

/**
 * Envia los tramites seleccionados al paso 2 del carrito
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const getCart2Details = (data) => httpClient.post('carrito/paso_2_detalles', data)

const getCartStep3 = (data) => httpClient.post('carrito/paso_3', data)

export {
    postIsProcedureInCart,
    addProcedureToCart,
    getNumberOfItems,
    getCartStep1,
    getProcedureAllItems,
    moveProcedureToCart,
    moveProcedureToWishlist,
    getCheckoutAllItems,
    removeItem,
    getCartStep2,
    getCart2Details,
    getCartStep3
}